import { create } from 'zustand';
import type { Tour } from './tours';

interface TourState {
  tour: Tour | null;
  replay: boolean;
  anchor: string | null;
  start: (tour: Tour, replay: boolean) => void;
  setAnchor: (anchor: string | null) => void;
  stop: () => void;
}

export const useTourStore = create<TourState>((set) => ({
  tour: null,
  replay: false,
  anchor: null,
  start: (tour, replay) => set({ tour, replay }),
  setAnchor: (anchor) => set({ anchor }),
  stop: () => set({ tour: null, replay: false, anchor: null }),
}));
